'use client';

import { useTranslation } from '@unifyapps/i18n/client';
import SvgArrowRight from '@unifyapps/icons/outline/ArrowRight';
import SvgLinkBroken01 from '@unifyapps/icons/outline/LinkBroken01';
import type { EmptyStateButtonProps } from '@unifyapps/ui/components/EmptyState';
import EmptyStateDefault from '@unifyapps/ui/components/EmptyState/variants/EmptyStateDefault';
import { Stack } from '@unifyapps/ui/components/Stack';
import { Link } from '../../navigation';

function NotFound({
  description,
  title,
  buttonProps,
}: {
  title?: string;
  description?: string;
  buttonProps?: EmptyStateButtonProps;
}) {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" className="h-screen w-full" justifyContent="center">
      <EmptyStateDefault
        buttons={[
          {
            label: t('common:BackToHome'),
            color: 'brand',
            variant: 'solid',
            component: Link,
            href: '/',
            endDecoratorComponent: SvgArrowRight,
            ...buttonProps,
          },
        ]}
        description={description || t('common:NotFound.Description')}
        Icon={SvgLinkBroken01}
        title={title || t('common:NotFound.Title')}
        variant="default"
      />
    </Stack>
  );
}

export default NotFound;
